import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'
import {onRowSelect,onAllRowSelect,customMultiSelect} from 'util/Utils';
import {
    FETCH_ADMIN_SUBSCRIPTIONS,
    DELETE_ADMIN_SUBSCRIPTION, ADD_ADMIN_SUBSCRIPTION,
    UPDATE_ADMIN_SUBSCRIPTION,
} from "actions/actionTypes";
import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList} from 'util/Utils';
import AdminSubscriptionListTable from 'dashboard/Subscriptions/AdminSubscriptionListTable';
import AdminSubscriptionSearchBox from 'dashboard/Subscriptions/AdminSubscriptionSearchBox'
import AdminSubscriptionsActionsBox from 'dashboard/Subscriptions/AdminSubscriptionsActionsBox'

import moment   from 'moment'


import config from  '../../../config';
import {validateEmail}  from 'util/Utils';
import RemoveModalDialog from'shared/RemoveModalDialog';
class AdminSubscriptionsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }


    constructor(props, context) {
        super(props, context);
        this.state = {
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            showModal: false,
           currentRecord: {},
            selectAllRecords:false,
            errors: {},
            recordIDs:[],
            allCategories: [],
        };
        this.toggleAllRecordsSelection = _.throttle(this.toggleAllRecordsSelection, 3000, {
            'leading': true,
            'trailing': false
        });
    };


    toggleAllRecordsSelection(value) {
        if (this.state.selectAllRecords) {
            this.setState({recordIDs: [], selectAllRecords: false});
        }else {
            this.search({include: ['_id'], all: true}).then(response => {

                this.setState({recordIDs: _.map(response.data.data, '_id'), selectAllRecords: true});
            })
        }
    }
    editRecord(row) {

        this.setState({
            showModal: true,
            currentRecord: {
                ...row,
            },

        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},

        });
    }

    showRemoveDialog(row) {
         this.setState({removeRecordModalVisible: true, currentRecord: row});
    }

    addNewSubscription() {
        this.setState({
            showModal: true,
            currentRecord: {
                Note: '',
                Variations: [],
            },

        });
    }

    deleteSubscription() {
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            type: 'patch',
            "endpoint": "/unsubscribe" + '/' + encodeURIComponent(this.state.currentRecord._id),
            'success_event': DELETE_ADMIN_SUBSCRIPTION,
            'success_event_data': {
                'recordID': this.state.currentRecord._id
            },
            messageData: {'#1#': 'Subscription'},
            messageCode: 'recordDeleted',
        };
        this.setState({currentRecord: {}});
        this.props.makeRequest({requestByAdministrator:true}, methodData).then(res => {
         }).catch(err => {
            console.log('e', err );
        });

    }

    validateAndGetFormData() {
            var formData = _.pick(this.state.currentRecord, ['Email', 'Type' ]),
            dataNotValid = false;

        if (!validateEmail(formData['Email'])) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Email is not valid'
            });
        }
        if (formData['Type'] == 'PriceDrop'){
            if (isNaN(this.state.currentRecord['DesirablePrice']) || this.state.currentRecord['DesirablePrice'] == 0 ) {
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Desirable price is not valid'
                });
            }
            formData['DesirablePrice'] = this.state.currentRecord['DesirablePrice']
        } else{
            formData['DesirablePrice'] = undefined;
        }

        console.log('formData', dataNotValid, formData);
        if (dataNotValid) {
            return false;
        }
        return formData
    }

    saveRecord() {
        console.log('in save record');
        var formData = this.validateAndGetFormData();
        console.log('form data', formData);
        if (!formData) {
            return false;
        }
        var methodData
        if (this.state.currentRecord._id) {
            methodData = {
                "endpoint": "/subscriptions/" + encodeURIComponent(this.state.currentRecord._id),
                type: "patch",
                success_event: UPDATE_ADMIN_SUBSCRIPTION,
                messageData: {'#1#': 'Subscription'},
                messageCode: 'recordUpdated'
            };
        } else {
            methodData = {
                "endpoint": "/subscriptions",
                type: "post",
                success_event: ADD_ADMIN_SUBSCRIPTION,
                messageData: {'#1#': 'GBG product'},
                messageCode: 'recordAdded'
            };
        }


        this.props.makeRequest(formData, methodData).then(res => {
            this.setState({
                showModal: false,
                currentRecord: {},
            })
        }).catch(err => {
        });

    }

    onSortChange(field, sortOrder) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {

        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})

        var {queryParams} = this.searchBox.getSearchParams();
         _.extend(queryParams, params);

        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
            queryParams.sortBySecondary  = '_id:-1'; /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */

        }
        if (queryParams.page === 1) {
            delete queryParams.page;
        }
        if (_.isUndefined(queryParams.page)) { /* do not clear selected records when only pagination is changed */
            this.setState({recordIDs:[]})
        }
        var methodData = {
            "endpoint": "/subscriptions",
            'not_display_success_message': true,
            'success_event': FETCH_ADMIN_SUBSCRIPTIONS
        };
        if (params.all){
           delete methodData.success_event
        }
        const stringified = queryString.stringify(_.omit(queryParams,['include', 'lookup', 'all','sortBySecondary']));
        this.context.router.push('/admin/subscriptions?' + stringified);
        return this.props.makeRequest(queryParams, methodData).then(res => {
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                console.log('before reset pagination');
                this.refs.pagination.resetPagination();
            }
            this.setState({pending:false})
            return res
        }).catch(err => {
            this.setState({pending:false})
        });
    }


    render() {
       // console.log('AdminSubscriptionsPage this state', this.state);

        return (
            <div >
                {/*<AdminProductActionsBox  search={this.search.bind(this)}   {...this.props} ></AdminProductActionsBox>*/}
                {config.checkAccessRights.call(this, {resources: ['subscriptions_full']}) &&
                <AdminSubscriptionsActionsBox
                    recordIDs={this.state.recordIDs} {...this.props } ></AdminSubscriptionsActionsBox>
                }
                <AdminSubscriptionSearchBox pending={this.state.pending}
                                            ref={(searchBox) => {
                        if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox;
                            if (_.size(_.get(this.props.location.query, 'recordIDs', []))  ) { /* by default search only if recordIDs are passed*/
                                this.search({page:this.state.currentPage+1})
                            }

                        }
                    } }
                    //  addNewSubscription={this.addNewSubscription.bind(this)}
                    search={this.search.bind(this)}
                    selectAllRecords = {this.state.selectAllRecords}
                    toggleAllRecordsSelection = {this.toggleAllRecordsSelection.bind(this)}
                    {...this.props} ></AdminSubscriptionSearchBox>
                {this.props.adminSubscriptions.fetched &&
                <div>
                    {this.props.adminSubscriptions.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'subscriptions')}</div> :
                        <div className="top20">

                            <AdminSubscriptionListTable
                                ref="table"
                                onSortChange={this.onSortChange.bind(this)}
                                showRemoveDialog={this.showRemoveDialog.bind(this)}
                                onRowSelect ={onRowSelect.bind(this)}
                                customMultiSelect ={customMultiSelect.bind(this)}
                                onAllRowSelect ={onAllRowSelect.bind(this)}
                                editRecord={this.editRecord.bind(this)}
                                search={this.search.bind(this)} {...this.props}  ></AdminSubscriptionListTable>
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={this.refs.searchBox ? this.refs.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)}
                                ref={'pagination'}
                                total={this.props.adminSubscriptions.total == 'initial' ? 0 : this.props.adminSubscriptions.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}
                </div>
                }
                <Modal  onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.currentRecord._id ? 'Edit' : 'Add new'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form  >

                            {/*<FormGroup>*/}
                            {/*<ControlLabel>GBG Product</ControlLabel>*/}
                            {/*<Select*/}
                            {/*tabIndex="0"*/}
                            {/*clearable={false}*/}
                            {/*placeholder=""*/}
                            {/*options={this.state.currentRecordCategoriesList}*/}
                            {/*onChange={(option) => this.onCategoryFormChange(option)}*/}
                            {/*value={this.state.currentRecord.Category}*/}
                            {/*/>*/}
                            {/*</FormGroup>*/}

                            <FormGroup>
                                <ControlLabel>Email</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Email: e.target.value
                                                 }
                                             })}
                                             value={this.state.currentRecord.Email }
                                              placeholder="Email"/>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Type</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    placeholder="Type"
                                    clearable={false}
                                    options={ _.map(config.subscriptionTypes, function (value, key) {
                                        return {value: key, label: value.label}
                                    })}
                                    onChange={(option) => {
                                        this.setState({
                                            'currentRecord': {
                                                ...this.state.currentRecord,
                                                Type: option.value,
                                            }
                                        });
                                    }}
                                    value={this.state.currentRecord.Type}
                                />
                            </FormGroup>
                            {this.state.currentRecord.Type == 'PriceDrop' &&
                            <FormGroup>
                                <ControlLabel>Desirable Price</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     DesirablePrice: e.target.value
                                                 }
                                             })}
                                             value={this.state.currentRecord.DesirablePrice }
                                             placeholder="Desirable Price"/>
                            </FormGroup>
                            }
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary " type="button"
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>
                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord = {(e) => this.deleteSubscription() }
                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
        adminSubscriptions: state.adminSubscriptions,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminSubscriptionsPage);
